require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./es-mx-project-lineamientos-chinos-que-aplican-a-bancos-1.json") })
        }
      }, "path---es-mx-project-lineamientos-chinos-que-aplican-a-bancos-1");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---es-mx-project-lineamientos-chinos-que-aplican-a-bancos-1!./.cache/json/es-mx-project-lineamientos-chinos-que-aplican-a-bancos-1.json
// module id = 899
// module chunks = 231608221292675